// Cross-linking SEO configuration — related pages for each thematic page.
// Each entry suggests 3 contextually related pages to boost SEO and keep users engaged.

export const relatedPagesMap = {
  'nutrition-hormonale': [
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Débloquez votre perte de poids en traitant les causes hormonales profondes.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'SOPK & Alimentation',
      description:
        "L'alimentation adaptée au syndrome des ovaires polykystiques (SOPK) pour rééquilibrer vos hormones.",
      path: '/sopk-alimentation'
    },
    {
      title: 'Préménopause & Métabolisme',
      description:
        "Accompagnement nutritionnel pour traverser la préménopause sereinement.",
      path: '/premenopause-metabolisme'
    }
  ],

  'perte-poids-hormonale': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Une alimentation ciblée pour rééquilibrer insuline, cortisol et hormones féminines.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Hypnose pour Maigrir',
      description:
        "Agir sur les compulsions et les blocages inconscients qui sabotent votre perte de poids.",
      path: '/hypnose-perte-de-poids-vevey-clarens'
    },
    {
      title: 'Préménopause & Métabolisme',
      description:
        "La prise de poids en préménopause n'est pas une fatalité — découvrez nos solutions.",
      path: '/premenopause-metabolisme'
    }
  ],

  'sopk-alimentation': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Comprenez le lien entre alimentation et équilibre hormonal au-delà du SOPK (syndrome des ovaires polykystiques).",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "70 % des femmes avec SOPK (syndrome des ovaires polykystiques) ont une résistance à l'insuline — traitons-la.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'Équilibre Émotionnel',
      description:
        "Le SOPK (syndrome des ovaires polykystiques) impacte aussi l'humeur et le bien-être — approche intégrative corps-esprit.",
      path: '/equilibre-emotionnel'
    }
  ],

  'premenopause-metabolisme': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Adaptez votre alimentation aux changements hormonaux de la préménopause.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Stoppez la prise de poids abdominale liée aux fluctuations hormonales.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'Santé Cardiovasculaire',
      description:
        "La préménopause augmente le risque cardiovasculaire — prenez soin de votre cœur.",
      path: '/sante-cardiovasculaire'
    }
  ],

  'sante-cardiovasculaire': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Une alimentation équilibrée au service de votre santé cardiaque et hormonale.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Préménopause & Métabolisme',
      description:
        "La préménopause modifie le profil cardiovasculaire — anticipez avec une prise en charge adaptée.",
      path: '/premenopause-metabolisme'
    },
    {
      title: 'Équilibre Émotionnel',
      description:
        "Stress et santé cardiovasculaire sont liés — découvrez notre approche globale.",
      path: '/equilibre-emotionnel'
    }
  ],

  'equilibre-emotionnel': [
    {
      title: 'Hypnopraxie®',
      description:
        "Une thérapie intégrative corps-esprit pour une maturation affective profonde.",
      path: '/hypnopraxie-vevey-montreux'
    },
    {
      title: 'Hypnose pour Maigrir',
      description:
        "Libérez-vous des compulsions alimentaires et du grignotage émotionnel.",
      path: '/hypnose-perte-de-poids-vevey-clarens'
    },
    {
      title: 'SOPK & Alimentation',
      description:
        "L'impact émotionnel du SOPK mérite une prise en charge globale.",
      path: '/sopk-alimentation'
    }
  ],

  'hypnose-perte-de-poids-vevey-clarens': [
    {
      title: 'Hypnopraxie®',
      description:
        "Découvrez la méthode avancée de l'hypnose créée par le Dr Guy Chedeau.",
      path: '/hypnopraxie-vevey-montreux'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Associez hypnose et nutrition hormonale pour des résultats durables.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'Équilibre Émotionnel',
      description:
        "Travaillez en profondeur sur la dimension émotionnelle de votre rapport à l'alimentation.",
      path: '/equilibre-emotionnel'
    }
  ],

  'hypnopraxie-vevey-montreux': [
    {
      title: 'Hypnose pour Maigrir',
      description:
        "Une application concrète de l'Hypnopraxie® dans l'accompagnement de la perte de poids.",
      path: '/hypnose-perte-de-poids-vevey-clarens'
    },
    {
      title: 'Équilibre Émotionnel',
      description:
        "Une approche complémentaire pour retrouver l'équilibre intérieur.",
      path: '/equilibre-emotionnel'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "L'Hypnopraxie® s'intègre parfaitement à un accompagnement nutritionnel.",
      path: '/perte-poids-hormonale'
    }
  ],

  'nutritionniste-vevey-clarens': [
    {
      title: 'Perte de Poids à Vevey & Clarens',
      description:
        "Programme de perte de poids personnalisé sur la Riviera vaudoise.",
      path: '/perte-de-poids-vevey-clarens'
    },
    {
      title: 'Nutrition Hormonale',
      description:
        "L'expertise d'une nutritionniste spécialisée en santé hormonale féminine.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Hypnopraxie® Vevey & Montreux',
      description:
        "Une approche complémentaire à la nutrition pour un équilibre global.",
      path: '/hypnopraxie-vevey-montreux'
    }
  ],

  'perte-de-poids-vevey-clarens': [
    {
      title: 'Nutritionniste Vevey & Clarens',
      description:
        "Consultations nutritionnelles personnalisées sur la Riviera vaudoise.",
      path: '/nutritionniste-vevey-clarens'
    },
    {
      title: 'Hypnose pour Maigrir',
      description:
        "Complétez votre programme de perte de poids par l'hypnose à Vevey.",
      path: '/hypnose-perte-de-poids-vevey-clarens'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Comprenez et traitez les causes hormonales qui bloquent votre perte de poids.",
      path: '/perte-poids-hormonale'
    }
  ],

  'fertilite-nutrition-femme': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Une alimentation ciblée pour rééquilibrer vos hormones et favoriser la fertilité.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'SOPK & Alimentation',
      description:
        "Le SOPK est l'une des causes principales d'infertilité — nous l'accompagnons spécifiquement.",
      path: '/sopk-alimentation'
    },
    {
      title: 'Rééquilibrage alimentaire',
      description:
        "Préparer votre corps à la grossesse par un rééquilibrage alimentaire complet.",
      path: '/reequilibrage-alimentaire-vevey-lausanne'
    }
  ],

  'compulsions-sucre-soir': [
    {
      title: 'Équilibre Émotionnel',
      description:
        "Les compulsions ont souvent une cause émotionnelle : nous travaillons aussi sur ce versant.",
      path: '/equilibre-emotionnel'
    },
    {
      title: 'Hypnopraxie® (méthode)',
      description:
        "L'hypnopraxie agit profondément sur les compulsions alimentaires et le rapport au sucre.",
      path: '/hypnopraxie-vevey-montreux'
    },
    {
      title: 'Résistance à l\'insuline',
      description:
        "Les fringales de sucre sont un signal de résistance à l'insuline — découvrez comment la traiter.",
      path: '/resistance-insuline-nutrition'
    }
  ],

  'retention-eau-jambes-lourdes': [
    {
      title: 'Nutrition Hormonale',
      description:
        "La rétention d'eau est souvent liée à un déséquilibre hormonal — explorons-le ensemble.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'Périménopause & Métabolisme',
      description:
        "La rétention d'eau s'accentue à la périménopause — nous l'accompagnons spécifiquement.",
      path: '/premenopause-metabolisme'
    },
    {
      title: 'Rééquilibrage alimentaire',
      description:
        "Un rééquilibrage global pour soulager durablement les jambes lourdes et la rétention.",
      path: '/reequilibrage-alimentaire-vevey-lausanne'
    }
  ],

  'reequilibrage-alimentaire-vevey-lausanne': [
    {
      title: 'Nutritionniste Vevey & Clarens',
      description:
        "Consultations nutritionnelles personnalisées sur la Riviera vaudoise.",
      path: '/nutritionniste-vevey-clarens'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Allez plus loin si votre poids reste bloqué malgré un rééquilibrage.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'Nutrition Hormonale',
      description:
        "Une alimentation ciblée selon votre profil hormonal pour des résultats durables.",
      path: '/nutrition-hormonale'
    }
  ],

  'resistance-insuline-nutrition': [
    {
      title: 'SOPK & Alimentation',
      description:
        "70 % des femmes avec SOPK ont une résistance à l'insuline — explorez ce lien.",
      path: '/sopk-alimentation'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "La résistance à l'insuline bloque la perte de poids — découvrez les solutions.",
      path: '/perte-poids-hormonale'
    },
    {
      title: 'Compulsions de sucre le soir',
      description:
        "Fringales et envies de sucre : des signaux typiques d'une résistance à l'insuline.",
      path: '/compulsions-sucre-soir'
    }
  ],

  'nutrition-sportive-vevey-montreux': [
    {
      title: 'Rééquilibrage alimentaire',
      description:
        "Optimisez vos performances par un rééquilibrage adapté à votre activité.",
      path: '/reequilibrage-alimentaire-vevey-lausanne'
    },
    {
      title: 'Santé cardiovasculaire',
      description:
        "Sport et santé cardiaque : un duo gagnant pour une longévité en pleine forme.",
      path: '/sante-cardiovasculaire'
    },
    {
      title: 'Nutritionniste Vevey & Clarens',
      description:
        "Consultations personnalisées pour les sportives sur la Riviera vaudoise.",
      path: '/nutritionniste-vevey-clarens'
    }
  ],

  'home': [
    {
      title: 'Nutrition Hormonale',
      description:
        "Une alimentation ciblée pour rééquilibrer vos hormones et retrouver l'équilibre.",
      path: '/nutrition-hormonale'
    },
    {
      title: 'SOPK & Alimentation',
      description:
        "L'alimentation adaptée au syndrome des ovaires polykystiques.",
      path: '/sopk-alimentation'
    },
    {
      title: 'Perte de Poids Hormonale',
      description:
        "Débloquez votre perte de poids en traitant les causes hormonales profondes.",
      path: '/perte-poids-hormonale'
    }
  ]
};
